import { render, staticRenderFns } from "./NewCalendarScreen.vue?vue&type=template&id=32c26f08"
import script from "./NewCalendarScreen.vue?vue&type=script&lang=js"
export * from "./NewCalendarScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports